import type { ContentRegistry } from "@/lib/content/registry";
import { hrmsContent } from "./hrms";
import { crmContent } from "./crm";

// Central list of every product content registry. The content sitemap and
// auto-nav iterate this — adding a new product means adding its registry here
// (plus its own catch-all route), and its pages are wired into both.
export const allRegistries: ContentRegistry[] = [hrmsContent, crmContent];
